import React, {Fragment, useCallback, useEffect, useState} from "react";
import {closePersonInfoPopupAction} from "module/PersonInfo/action/PersonInfoAction";
import {fetchPersonInfo, fetchVerrBis, fetchVlErrors} from "module/PersonInfo/api/PersonInfoAPI";
import {getSisDateAsISO, getSisDateAsNumber, parseSisDate} from "util/SisDateTime";
import {VlErrorList} from "module/PersonInfo/component/VlErrorList";
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import {Modal} from 'module/Modal/component/Modal';
import {PersonInfoList} from 'module/PersonInfo/component/PersonInfoList';
import {ModalKey} from 'module/Modal/type/ModalKey';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {useDispatch} from 'react-redux';
import {VlFehl} from 'generated/JavaTOmodifications';

const useStyles = makeStyles(theme => ({
	subHeader: {
		background: '#f9f9f9',
	},
	container: {
		height: '100%',
		overflow: 'auto',
	},
	divider: {
		position: 'sticky',
		top: 0,
	},
}), {name: 'PersonInfoModal'});

interface Props {
	open: boolean
	header: string
	persNr: number
	date: number
}

export const PersonInfoModal = ({open, header, persNr, date}: Props) => {
	const dispatch = useDispatch()
	const classes = useStyles();
	const onClose = useCallback(() => dispatch(closePersonInfoPopupAction()), [dispatch]);
	const [validUntil, setValidUntil] = useState<number>(NaN);
	const [vlErrors, setVlErrors] = useState<VlFehl[]>([]);
	const [personInfo, setPersonInfo] = useState<string[]>([]);
	useEffect(() => {
		if (!persNr) setValidUntil(NaN);
		else fetchVerrBis(persNr).then(({data}) =>
			setValidUntil(getSisDateAsNumber(
				parseSisDate(data).subtract(1, 'day'),
			)));
	}, [persNr]);
	useEffect(() => {
		if (!persNr) setVlErrors([]);
		else fetchVlErrors(persNr).then(({data}) => setVlErrors(data));
	}, [persNr]);
	useEffect(() => {
		if (!persNr) setPersonInfo([]);
		else fetchPersonInfo(persNr, date).then(({data}) => setPersonInfo(data));
	}, [persNr, date]);
	const vl1 = vlErrors.filter(vl => vl.datum >= validUntil);
	const vl2 = vlErrors.filter(vl => vl.datum < validUntil);
	return (
		<Modal
			modalKey={ModalKey.PersonInfo}
			open={open}
			title={header}
			defaultSize={{width: 450, height: 700}}
			onClose={onClose}
		>
			<div className={classes.container}>
				<List dense={true}>
					<Fragment>
						<ListSubheader className={classes.subHeader}>
							Gültig erfasst bis {validUntil && getSisDateAsISO(validUntil)}
						</ListSubheader>
						{!vl1.length ||
						<Fragment>
							<Divider className={classes.divider}/>
							<ListSubheader className={classes.subHeader}>
								Fehler
							</ListSubheader>
							<ListItem>
								<VlErrorList models={vl1}/>
							</ListItem>
						</Fragment>
						}
						{!vl2.length ||
						<Fragment>
							<Divider className={classes.divider}/>
							<ListSubheader className={classes.subHeader}>
								Fehler aus vorherigen Verrechnungen
							</ListSubheader>
							<ListItem dense={true}>
								<VlErrorList models={vl2}/>
							</ListItem>
						</Fragment>
						}
						{!personInfo.length ||
						<Fragment>
							<Divider className={classes.divider}/>
							<ListSubheader className={classes.subHeader}>
								Informationen zur Person
							</ListSubheader>
							<ListItem>
								<PersonInfoList models={personInfo}/>
							</ListItem>
						</Fragment>
						}
					</Fragment>
				</List>
			</div>
		</Modal>
	);
};